import { CreditMemoCreate } from './CreditMemoCreate';
import { CreditMemoShow } from './CreditMemoShow';

const CreditMemos = {
  create: CreditMemoCreate,
  show: CreditMemoShow,
};

export default CreditMemos;
